export default __webpack_public_path__ + "static/media/Icon-feather-map-pin.0b6436d6.svg";